import { render, staticRenderFns } from "./EmployeeInformation.vue?vue&type=template&id=24860c94&scoped=true"
import script from "./EmployeeInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInformation.vue?vue&type=style&index=0&id=24860c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24860c94",
  null
  
)

export default component.exports